var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-card',{ref:"card",attrs:{"title":"Opłata za interwencję","actions":_vm.actions,"handler":_vm.handlerClick,"titleClass":"pb-0"}},[_c('v-card-text',{staticClass:"pt-0 px-0"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),_c('v-card-text',[_c('payment-list',{attrs:{"payments":_vm.costs},on:{"payment-changed":_vm.onPaymentChanged}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }